import { Button } from 'components/atoms/button/index';
import InputZipCode from 'components/atoms/input-zip-code';
import { useAsync } from 'context/async-context';
import { useStepsContext } from 'context/steps-context';
import { ILead } from 'models/lead';
import { ILocation } from 'models/location';
import { useState } from 'react';
import { Typography } from 'styles/typography';

const RegisterZipCode = () => {
  const [location, setLocation] = useState<ILocation>();
  const { nextStep, patchData, getData } = useStepsContext();
  const { handledAsync } = useAsync();

  const savedData = getData<ILead>();

  const btnClicked = () => {
    handledAsync(async () => {
      await patchData<ILead>({ location }, true);
      nextStep();
    });
  };

  return (
    <>
      <Typography
        as="h3"
        color="title"
        fontSize="heading3"
        fontWeight="bold"
        lineHeight="48px"
        display="block"
        letterSpacing="-0.01em"
        margin="0 0 41px"
      >
        Qual seu CEP?
      </Typography>

      <Typography
        as="a"
        textDecoration="underline"
        color="text"
        fontSize="body1"
        margin="0 0 36px"
        href="https://buscacepinter.correios.com.br/app/endereco/index.php?t"
        target="_blank"
        rel="noopener noreferrer nofollow"
      >
        Não sei meu CEP
      </Typography>
      <InputZipCode
        initialData={savedData.location?.zipcode}
        onChange={setLocation}
      />
      <Button disabled={!location} onClick={btnClicked}>
        Continuar
      </Button>
    </>
  );
};

export default RegisterZipCode;
